// ** MUI Imports
import { Theme } from "@mui/material/styles";

const Skeleton = (theme: Theme) => {
  return {
    MuiSkeleton: {
      defaultProps: {
        variant: "rounded",
      },
      styleOverrides: {
        root: {
          height: 24,
          width: '100%',
        },
      },
    },
  };
};

export default Skeleton;
